var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.centerDialogVisible, width: "75%", center: "" },
      on: {
        "update:visible": function ($event) {
          _vm.centerDialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v(" 添加参与活动的商品 ")]),
      _c("div", { staticClass: "selectBox" }, [
        _c(
          "div",
          { staticClass: "selectBoxL" },
          [
            _c(
              "el-button",
              {
                staticStyle: { "margin-bottom": "0.1rem" },
                attrs: {
                  size: "small",
                  icon: "el-icon-search",
                  type: "primary",
                },
              },
              [_vm._v("搜索")]
            ),
            _c("p", [_vm._v("重置")]),
          ],
          1
        ),
        _c("div", { staticClass: "line" }),
        _c(
          "div",
          { staticClass: "selectBoxR" },
          [
            _c(
              "div",
              { staticClass: "selectBoxRLineBox" },
              _vm._l(_vm.typeList, function (item, index) {
                return _c(
                  "el-button",
                  { key: index, staticClass: "selectBtn" },
                  [_vm._v(" " + _vm._s(item.name))]
                )
              }),
              1
            ),
            _c(
              "div",
              { staticClass: "selectBoxRLineBox" },
              _vm._l(_vm.resourceType, function (item) {
                return _c(
                  "el-button",
                  { key: item.code, staticClass: "selectBtn" },
                  [_vm._v(" " + _vm._s(item.name1))]
                )
              }),
              1
            ),
            _c("el-input", {
              staticStyle: { width: "4rem" },
              attrs: { placeholder: "输入产品名称、地点等" },
            }),
          ],
          1
        ),
      ]),
      _c("goodsTable"),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.centerDialogVisible = false
                },
              },
            },
            [_vm._v("确 认")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.centerDialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }